
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-platinum-benefits',
  imports: [TranslateModule],
  templateUrl: './platinum-benefits.component.html',
  styleUrl: './platinum-benefits.component.scss'
})
export class PlatinumBenefitsComponent {

}
